import type { AppState } from 'state/state.model';

import type { QuoteRegulationInfos } from './regulation.model';
import { initialRegulationInfos } from './regulation.model';

export function getRegulationInfos(state: AppState, tabId: string, quoteId: string): QuoteRegulationInfos | undefined {
  const stateByTab = state.quotes.regulations[tabId];

  if (stateByTab === undefined) {
    return undefined;
  }
  return stateByTab[quoteId];
}

export function getRegulationInfosOrDefault(
  state: AppState,
  tabId: string,
  quoteId: string | undefined,
): QuoteRegulationInfos {
  if (quoteId === undefined) {
    return initialRegulationInfos;
  }
  return getRegulationInfos(state, tabId, quoteId) ?? initialRegulationInfos;
}

export function hasRegulationOnQuote(state: AppState, tabId: string, quoteId: string) {
  return getRegulationInfos(state, tabId, quoteId) !== undefined;
}
